import { ApiService } from '../../services/api.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss'],
})
export class PaymentFormComponent implements OnInit {
  @Input() bountyId: number;
  @Input() amount: number;
  public loading = false;
  public error: string;

  constructor(
    private apiService: ApiService,
  ) { }

  ngOnInit() {
  }

  public async proceedToCheckout() {
    if (this.amount < 1 || this.amount > 1000) {
      this.loading = false;
      this.error = 'The amount must be between $1 and $1000';
      return;
    }

    this.loading = true;
    this.error = undefined;
    const amountPlusFee = this.amount * 1.1;

    try {
      const { redirectUrl }: any = await this.apiService
        .post('paypal-checkout', { bountyId: this.bountyId, amount: amountPlusFee })
        .toPromise();

      window.location.href = redirectUrl;
    } catch (e) {
      if (e.status === 401) {
        this.error = 'You must be logged in to contribute. Please sign up first.';
      } else if (e.error && e.error.error) {
        this.error = e.error.error;
      } else {
        this.error = 'Server error occured. Please contact support';
      }
      this.loading = false;
    }
  }
}
